<!-- eslint-disable -->
<template>
  <a
    v-if="atsToUse && url"
    :href="url"
    target="_blank"
    rel="noopener noreferrer"
    @click="trackAtsClick"
    class="d-flex align-center justify-center"
  >
    <div class="icon-container">
      <DpplSvg
        class="icon"
        :file-name="atsToUse"
      />
    </div>
  </a>
  <span v-else>
    -
  </span>
</template>

<script setup>
import { computed } from 'vue';
import {
  SMARTRECRUITERS, GREENHOUSE, GR8PEOPLE, LEVER, WORKDAY, SUCCESSFACTORS, ICIMS,
} from '@/helpers/constants/atsIds';
import { useAppAuthData } from '@/stores/app/authData';
import { storeToRefs } from 'pinia';
import DpplSvg from '@/components/datapeople/DpplSvg.vue';

const props = defineProps({
  url: { type: String, default: null },
});

const emits = defineEmits(['track-ats-click']);

const { authData } = storeToRefs(useAppAuthData());

const atsIds = {
  [GREENHOUSE]: 'greenhouse',
  [SMARTRECRUITERS]: 'smartrecruiters',
  [GR8PEOPLE]: 'gr8people',
  [LEVER]: 'lever',
  [WORKDAY]: 'workday',
  [SUCCESSFACTORS]: 'successfactors',
  [ICIMS]: 'icims',
};

const atsToUse = computed(() => atsIds[authData.value?.atsId]);

const trackAtsClick = () => {
  emits('track-ats-click', props.url);
};
</script>

<style lang="less" scoped>
.icon {
  max-width: 100%;
  max-height: 100%;
}

.icon-container {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
